import axios from 'axios'

export function getAxios (settings, timeout = 20000) {
  const ins = axios.create(settings)
  axios.defaults.timeout = timeout
  setInterceptors(ins)
  return ins
}
function setInterceptors (axiosIns) {
  // 请求拦截
  axiosIns.interceptors.request.use(config => {
    return config
  }, error => {
    // eslint-disable-next-line
    console.log('error' + error)
    return Promise.reject(error)
  })
  // 响应拦截
  axiosIns.interceptors.response.use(response => {
    return Object.hasOwnProperty.call(response, 'data') ? response.data : response
  }, error => {
    try {
      const { status } = error.response
      return { code: status }
    } catch (err) {
    }
    // 获取错误的状态码
    return Promise.reject(error)
  })
}
